import { render, staticRenderFns } from "./TeacherTimeTable.vue?vue&type=template&id=b1482856&scoped=true&"
import script from "./TeacherTimeTable.vue?vue&type=script&lang=js&"
export * from "./TeacherTimeTable.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTimeTable.vue?vue&type=style&index=0&id=b1482856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1482856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VRow})
